import { GADimension } from '@ps/web-core-enums';
import type { Optional } from 'utility-types';

import type { InputFill } from '../events';
import type { TrackingContextValue } from '../providers/TrackingContext';
import { GAEvent, memoize } from '../utils';

export const searchFilled = memoize(
  (context: TrackingContextValue, data: Optional<InputFill, 'isAutoFilled'>) =>
    GAEvent({ action: 'Input Filled', label: data.fieldName }, context, {
      [GADimension.InputValue]: data.strInput
    }),
  '2.fieldContent'
);
